import aggregateFunctionUtility from "./aggregateUtility";
import { number } from "prop-types";

function conversionEngine(stages, organizationId, previousKeywords) {
	var finalStageArray = [];
	for (var i = 0; i < stages.length; i++) {
		var localThinkerStage = [];
		localThinkerStage = getStageData(
			stages[i],
			organizationId,
			previousKeywords[i] ? previousKeywords[i] : []
		);
		finalStageArray = finalStageArray.concat(localThinkerStage);
	}
	return finalStageArray;
}

function getStageData(obj, organizationId, previousKeywords) {
	switch (obj.stage) {
		case "selectKeywords":
			return selectKeywords(obj);
		case "unwind":
			return unwind(obj);
		case "extractTable":
			return extractTable(obj);
		case "sort":
			return sort(obj);
		case "limit":
			return limit(obj);
		case "skip":
			return skip(obj);
		case "removeFields":
			return removefields(obj);
		case "addField":
			return addfield(obj);
		case "addFilter":
			return addfilter(obj);
		case "addFieldLookup":
			return addFieldLookup(obj);
		case "addFieldCalculated":
			return addFieldCalculated(obj);
		case "addFieldParent":
			return addFieldParent(obj);
		case "getFieldNames":
			return getFieldNames(obj);
		case "addAttributedFields":
			return addAttributedFields(obj);
		case "pivot":
			return pivot(obj);
		case "groupBy":
			return groupBy(obj);
		case "collate":
			return collate(obj);
		case "changeField":
			return changeField(obj);
		case "renameMultipleField":
			return renameMultipleField(obj);
		case "currentTime":
			return currentTime(obj);
		case "union":
			return unionFunction(obj, organizationId, previousKeywords);
		default:
			return [];
	}
}

function unwind(stageObj) {
	var localGroupStages = [];
	var localStageObj = {};
	localStageObj[stageObj.stage.toLowerCase()] = {
		path: `$${stageObj.query.keyword}`,
		preserveNullAndEmptyArrays: stageObj.query.nullAndEmpty === "remove" ? false : true
	};
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function extractTable(stageObj) {
	var localGroupStages = [];
	var localStageObj = {};
	localStageObj[stageObj.stage] = {
		tableName: stageObj.query.tableName,
		rowLabel: stageObj.query.key,
		columnNames: stageObj.query.columnNames
	};
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function getFieldNames(stageObj) {
	var localGroupStages = [];
	if (stageObj.query.type.includes("time-range")) {
		localGroupStages = [
			{
				join: {
					from: "tagElement",
					localColumn: stageObj.query.keyword,
					foreignColumn: "tagElementId",
					as: stageObj.query.newField + "1"
				}
			},
			{
				addfields: {
					[stageObj.query.newField]: {
						start: {
							$dateToString: {
								date: `$${stageObj.query.newField}1.start`,
								format: "%Y-%m-%dT%H:%M:%S.%LZ"
							}
						},
						end: {
							$dateToString: {
								date: `$${stageObj.query.newField}1.end`,
								format: "%Y-%m-%dT%H:%M:%S.%LZ"
							}
						}
					}
				}
			},
			{ removefields: [stageObj.query.newField + "1"] }
		];
	} else if (stageObj.query.type.includes("parent")) {
		var type = stageObj.query.type.split("-");
		localGroupStages = [
			{
				join: {
					from: type[0],
					localColumn: stageObj.query.keyword,
					foreignColumn: `${type[0]}Id`,
					as: stageObj.query.newField
				}
			},
			{
				addfields: {
					[stageObj.query.newField]: `$${stageObj.query.newField}.parentId`
				}
			}
		];
	} else if (stageObj.query.type.includes("map") || stageObj.query.type.includes("geo")) {
		let newField = stageObj.query.newField;
		localGroupStages = [
			{
				join: {
					from: "tagElement",
					localColumn: stageObj.query.keyword,
					foreignColumn: "tagElementId",
					as: newField
				}
			},
			{
				addfields: {
					[newField]: `$${newField}.refTagElementMetadataId`
				}
			},
			{
				join: {
					from: "refTagElementMetadata",
					localColumn: newField,
					foreignColumn: "_id",
					as: newField
				}
			}
		];
		if (stageObj.query.type.includes("map")) {
			localGroupStages.push({
				addfields: {
					[newField]: `$${newField}.code`
				}
			});
		} else {
			localGroupStages.push({
				addfields: {
					[newField]: {
						$cond: [
							{ $gt: [`$${newField}`, null] },
							[
								{
									$divide: [
										{
											$trunc: {
												$multiply: [`$${newField}.lat`, 100000]
											}
										},
										100000
									]
								},
								{
									$divide: [
										{
											$trunc: {
												$multiply: [`$${newField}.long`, 100000]
											}
										},
										100000
									]
								}
							],
							[]
						]
					}
				}
			});
		}
	} else {
		localGroupStages = [
			{
				join: {
					from: stageObj.query.type,
					localColumn: stageObj.query.keyword,
					foreignColumn: stageObj.query.type + "Id",
					as: stageObj.query.newField
				}
			},
			{
				addfields: {
					[stageObj.query.newField]: `$${stageObj.query.newField}.name`
				}
			}
		];
	}
	return localGroupStages;
}

function addAttributedFields(stageObj) {
	return [
		...[].concat(
			...stageObj.query.addAttributedMultiples.map(oneUnion => {
				let oneUnionStage = [];
				if (oneUnion.type.includes("time-range")) {
					oneUnionStage = [
						{
							join: {
								from: "tagElement",
								localColumn: oneUnion.keyword,
								foreignColumn: "tagElementId",
								as: oneUnion.newField + "1"
							}
						},
						{
							addfields: {
								[oneUnion.newField]: {
									start: {
										$dateToString: {
											date: `$${oneUnion.newField}1.start`,
											format: "%Y-%m-%dT%H:%M:%S.%LZ"
										}
									},
									end: {
										$dateToString: {
											date: `$${oneUnion.newField}1.end`,
											format: "%Y-%m-%dT%H:%M:%S.%LZ"
										}
									}
								}
							}
						},
						{ removefields: [oneUnion.newField + "1"] }
					];
				} else if (oneUnion.type.includes("parent")) {
					var type = oneUnion.type.split("-");
					oneUnionStage = [
						{
							join: {
								from: type[0],
								localColumn: oneUnion.keyword,
								foreignColumn: `${type[0]}Id`,
								as: oneUnion.newField
							}
						},
						{
							addfields: {
								[oneUnion.newField]: `$${oneUnion.newField}.parentId`
							}
						}
					];
				} else if (oneUnion.type.includes("map") || oneUnion.type.includes("geo")) {
					let newField = oneUnion.newField;
					oneUnionStage = [
						{
							join: {
								from: "tagElement",
								localColumn: oneUnion.keyword,
								foreignColumn: "tagElementId",
								as: newField
							}
						},
						{
							addfields: {
								[newField]: `$${newField}.refTagElementMetadataId`
							}
						},
						{
							join: {
								from: "refTagElementMetadata",
								localColumn: newField,
								foreignColumn: "_id",
								as: newField
							}
						}
					];
					if (oneUnion.type.includes("map")) {
						oneUnionStage.push({
							addfields: {
								[newField]: `$${newField}.code`
							}
						});
					} else {
						oneUnionStage.push({
							addfields: {
								[newField]: {
									$cond: [
										{ $gt: [`$${newField}`, null] },
										[
											{
												$divide: [
													{
														$trunc: {
															$multiply: [`$${newField}.lat`, 100000]
														}
													},
													100000
												]
											},
											{
												$divide: [
													{
														$trunc: {
															$multiply: [`$${newField}.long`, 100000]
														}
													},
													100000
												]
											}
										],
										[]
									]
								}
							}
						});
					}
				} else {
					oneUnionStage = [
						{
							join: {
								from: oneUnion.type,
								localColumn: oneUnion.keyword,
								foreignColumn: oneUnion.type + "Id",
								as: oneUnion.newField
							}
						},
						{
							addfields: {
								[oneUnion.newField]: `$${oneUnion.newField}.name`
							}
						}
					];
				}
				return oneUnionStage;
			})
		)
	];
}

function pivot(stageObj) {
	var localGroupStages = [];
	localGroupStages = [
		{
			pivot: {
				selectFields: stageObj.query.keywords,
				dimension: stageObj.query.dimension,
				value: stageObj.query.value
			}
		}
	];
	return localGroupStages;
}

function selectKeywords(stageObj) {
	var localGroupStages = [];
	var localStageObj = {};
	localStageObj["selectfields"] = stageObj.query.keywords;
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function sort(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj[stageObj.stage.toLowerCase()] = {};
	for (var i = 0; i < stageObj.query.sortData.length; i++) {
		localStageObj[stageObj.stage][stageObj.query.sortData[i].key] =
			stageObj.query.sortData[i].order === "asc" ? 1 : -1;
	}
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function limit(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj[stageObj.stage.toLowerCase()] = stageObj.query.no_of_entries;
	localGroupStages.push(localStageObj);
	return localGroupStages;
}
function skip(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj[stageObj.stage.toLowerCase()] = stageObj.query.no_of_entries;
	localGroupStages.push(localStageObj);
	return [{ [stageObj.stage.toLowerCase()]: stageObj.query.no_of_entries }];
}

function removefields(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	var keywords = stageObj.query.keywords;
	localStageObj[stageObj.stage.toLowerCase()] = [...keywords];
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function addfield(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	if (stageObj.query.type === "lookup") {
		localStageObj["join"] = {
			from: stageObj.query.details.referenceTable,
			localColumn: stageObj.query.details.lookupField,
			foreignColumn: stageObj.query.details.matchField,
			as: stageObj.query.details.referenceTable + "data"
		};
		localGroupStages.push(localStageObj);
		localStageObj = {};
		localStageObj["addfields"] = {};
		for (var i = 0; i < stageObj.query.details.selectKeys.length; i++) {
			localStageObj.addfields[stageObj.query.details.selectKeys[i]] =
				"$" + stageObj.query.details.referenceTable + "data." + stageObj.query.details.selectKeys[i];
		}
	} else if (stageObj.query.type === "parent") {
		localStageObj["join"] = {
			from: "tagElement",
			localColumn: stageObj.query.details.lookup_keyword,
			foreignColumn: "tagElementId",
			as: "tagElementdata"
		};
		localGroupStages.push(localStageObj);
		localStageObj = {};
		localStageObj["addfields"] = {
			[stageObj.query.details.new_keyword]: "$tagElementdata." + stageObj.query.details.new_keyword
		};
	}

	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function addFieldLookup(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj["join"] = {
		from: stageObj.query.referenceTable,
		localColumn: stageObj.query.matchField,
		foreignColumn: stageObj.query.lookupField,
		as: "data" + stageObj.query.referenceTable
	};
	localGroupStages.push(localStageObj);
	localStageObj = {};
	localStageObj["addfields"] = {};
	for (var i = 0; i < stageObj.query.selectKeys.length; i++) {
		localStageObj.addfields[stageObj.query.selectKeys[i]] =
			"$" + "data" + stageObj.query.referenceTable + "." + stageObj.query.selectKeys[i];
	}
	localGroupStages.push(localStageObj);
	localStageObj = {};
	localStageObj["removefields"] = [`data${stageObj.query.referenceTable}`];
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function addFieldParent(stageObj) {
	var localGroupStages = [
		{
			join: {
				from: `${stageObj.query.foreignTable}`,
				localColumn: `${stageObj.query.keyword}`,
				foreignColumn: `${stageObj.query.foreignField}`,
				as: `data_parent_${stageObj.query.keyword}`
			}
		},
		{
			addfields: {
				[stageObj.query.newField]: `$data_parent_${stageObj.query.keyword}.parentId`
			}
		},
		{
			removefields: [`data_parent_${stageObj.query.keyword}`]
		}
	];
	return localGroupStages;
}

function adjustedTime(str) {
	if (str) {
		let sign = str.includes("-") ? str[0] : "p",
			num = str.slice(2);
		return sign === "n" ? -(num * 60000) : num * 60000;
	} else return 0;
}

function currentTime(stageObj) {
	var localGroupStages = [];
	if (stageObj && stageObj.query) {
		stageObj.query.addCurrentTime.map(fieldObj => {
			const adjustment = adjustedTime(fieldObj.adjustment);
			localGroupStages.push({ currentTime: { keyword: fieldObj.keyword, adjustment: adjustment } });
		});
	}
	return localGroupStages;
}

function addFieldCalculated(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	if (stageObj && stageObj.query) {
		localStageObj["addfields"] = stageObj.query.addField.reduce((result, fieldObj) => {
			result[fieldObj.newField] = fieldObj.expression;
			return result;
		}, {});
	}
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function groupBy(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	var { keywords, aggregateData } = stageObj.query;
	localStageObj["group"] = {
		by: keywords,
		fields: aggregateData.reduce((result, aggregateObj) => {
			result = { ...result, ...aggregateFunctionUtility(aggregateObj) };
			return result;
		}, {})
	};
	if (
		keywords != undefined &&
		stageObj.query.buckets &&
		keywords.length > 0 &&
		stageObj.query.buckets.length >= 1
	) {
		localStageObj["group"]["boundaries"] = convertNumberStringToNumber(stageObj.query.buckets);
		localStageObj["group"]["default"] = "other";

		localGroupStages.push(localStageObj);
		localStageObj = {};
		localStageObj["addfields"] = {
			[keywords[0]]: "$id"
		};
		localGroupStages.push(localStageObj);
		localStageObj = {
			removefields: ["id"]
		};
		localGroupStages.push(localStageObj);
	} else {
		localGroupStages.push(localStageObj);
		localStageObj = {};
		if (keywords !== undefined && keywords.length > 0) {
			localStageObj["addfields"] = keywords.reduce((result, keyword) => {
				result[keyword] = `$id.${keyword}`;
				return result;
			}, {});
			localGroupStages.push(localStageObj);
		}
		localStageObj = {
			removefields: ["id"]
		};
		localGroupStages.push(localStageObj);
	}
	return localGroupStages;
}

function collate(stageObj) {
	var { keywords, aggregators } = stageObj.query;
	var results = [],
		addfields = {
			addfields: {}
		};

	results.push({
		group: {
			by: aggregators,
			collate: keywords
		}
	});
	if (aggregators !== undefined && aggregators.length > 0) {
		aggregators.map(aggregator => {
			addfields.addfields[aggregator] = `$id.${aggregator}`;
		});
		results.push(addfields);
	}
	return results;
}

function unionFunction(stageObj, organizationId, previousKeywords) {
	var { table, keywords } = stageObj.query;
	var results = [];
	if (keywords.length) {
		results = [
			{
				addfields: {
					organizationId
				}
			},
			{ union: table },
			{ selectfields: [...new Set([...keywords, ...previousKeywords])] }
		];
	}
	return results;
}

function addfilter(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj = getApplyFilterData(stageObj);
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function convertNumberStringToNumber(value) {
	let numberValues = [];
	if (Array.isArray(value)) {
		numberValues = value.map(elem => {
			return parseInt(elem);
		});
		return numberValues;
	} else {
		return parseInt(value);
	}
}

function changeField(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj["addfields"] = {};
	localStageObj["addfields"][stageObj.query.newField] = `$${stageObj.query.keyword}`;
	localGroupStages.push(localStageObj);
	localStageObj = {};
	localStageObj["removefields"] = [stageObj.query.keyword];
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function renameMultipleField(stageObj) {
	var localGroupStages = [],
		localStageObj = {};
	localStageObj["addfields"] = {};
	var keywords = [];
	for (var i = 0; i < stageObj.query.renameMultipleField.length; i++) {
		localStageObj["addfields"][
			stageObj.query.renameMultipleField[i].newField
		] = `$${stageObj.query.renameMultipleField[i].keyword}`;
		keywords.push(stageObj.query.renameMultipleField[i].keyword);
	}
	localGroupStages.push(localStageObj);
	localStageObj = {};
	localStageObj["removefields"] = keywords;
	localGroupStages.push(localStageObj);
	return localGroupStages;
}

function getApplyFilterData(stageObj) {
	switch (stageObj.query.operator) {
		case "global_is_empty":
			return global_is_empty(stageObj);
		case "global_not_empty":
			return global_not_empty(stageObj);
		case "global_blank":
			return global_blank(stageObj);
		case "global_not_blank":
			return global_not_blank(stageObj);
		case "date_between":
			return between(stageObj);
		case "date_greater_than":
			return greater_than(stageObj);
		case "date_less_than":
			return less_than(stageObj);
		case "num_between":
			return between(stageObj);
		case "num_greater_than":
			return greater_than(stageObj);
		case "num_less_than":
			return less_than(stageObj);
		case "num_equal_to":
			return value_in(stageObj);
		case "text_is":
			return value_in(stageObj);
		case "num_not_equal_to":
			return value_not_in(stageObj);
		case "text_is_not":
			return value_not_in(stageObj);
		case "num_greater_equal_to":
			return greater_than_equal_to(stageObj);
		case "num_less_equal_to":
			return less_than_equal_to(stageObj);
		case "tag_is":
			return value_in(stageObj);
		case "tag_is_not":
			return value_not_in(stageObj);
		case "project_is":
			return value_in(stageObj);
		case "project_is_not":
			return value_not_in(stageObj);
		case "profile_ref_is":
			return value_in(stageObj);
		case "profile_ref_is_not":
			return value_not_in(stageObj);
	}
}

function global_is_empty(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {};
	localStageObj["where"][stageObj.query.keyword] = {
		$in: [null]
	};
	return localStageObj;
}

function global_not_empty(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$exists: true,
			$nin: [null]
		}
	};
	return localStageObj;
}

function global_not_blank(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$exists: true,
			$ne: ""
		}
	};
	return localStageObj;
}

function global_blank(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$exists: true,
			$eq: ""
		}
	};
	return localStageObj;
}

function between(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$lte: stageObj.query.filterExp.end,
			$gte: stageObj.query.filterExp.start
		}
	};
	return localStageObj;
}

function greater_than(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$gt: stageObj.query.filterExp
		}
	};
	return localStageObj;
}

function less_than(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$lt: stageObj.query.filterExp
		}
	};
	return localStageObj;
}

function greater_than_equal_to(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$gte: stageObj.query.filterExp
		}
	};
	return localStageObj;
}

function less_than_equal_to(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: {
			$lte: stageObj.query.filterExp
		}
	};
	return localStageObj;
}

function value_in(stageObj) {
	var localStageObj = {};
	if (stageObj.query && stageObj.query.operator == "num_equal_to") {
		localStageObj["where"] = {
			[stageObj.query.keyword]: {
				$in: convertNumberStringToNumber(stageObj.query.filterExp)
			}
		};
	} else {
		localStageObj["where"] = {
			[stageObj.query.keyword]: {
				$in: stageObj.query.filterExp
			}
		};
	}
	return localStageObj;
}

function value_not_in(stageObj) {
	var localStageObj = {};
	if (stageObj.query && stageObj.query.operator == "num_not_equal_to") {
		localStageObj["where"] = {
			[stageObj.query.keyword]: {
				$nin: convertNumberStringToNumber(stageObj.query.filterExp)
			}
		};
	} else {
		localStageObj["where"] = {
			[stageObj.query.keyword]: {
				$nin: stageObj.query.filterExp
			}
		};
	}
	return localStageObj;
}

function equal_to(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: stageObj.query.filterExp
	};
	return localStageObj;
}

function not_equal_to(stageObj) {
	var localStageObj = {};
	localStageObj["where"] = {
		[stageObj.query.keyword]: { $ne: stageObj.query.filterExp }
	};
	return localStageObj;
}

const conversionEngineWrapper = (uiQuery, mode = "execute", previousKeywords = []) => {
	if (mode === "execute") {
		return {
			table: uiQuery.baseTable,
			organizationId: uiQuery.organizationID,
			query: conversionEngine(uiQuery.query, uiQuery.organizationID, previousKeywords),
			title: uiQuery.title
		};
	} else if (mode === "save") {
		return {
			table: uiQuery.baseTable,
			organizationId: uiQuery.organizationID,
			pipeline: conversionEngine(uiQuery.query, uiQuery.organizationID, previousKeywords),
			title: uiQuery.title
		};
	}
};

export default conversionEngineWrapper;
